import styled from 'styled-components';
import rtl from 'styled-components-rtl';
import { theme, toRem } from '@marriott/mi-ui-library-shop';

export const StyledRecentViewAndSearch = styled.div`
  ${rtl`
  margin-top: ${toRem(9)};
  position: relative;
  @media ${theme.mediaQuery.mobileOnly} {
    padding-bottom: ${toRem(23)};
    margin-top: 0;
    height: calc(100vh - ${toRem(109)});
    background-color: ${theme.color['white']};
    overflow: hidden;
  }
  .search-history-btm-cta-wrapper {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
    padding-bottom: ${toRem(32)};
    button {
      border: none;
      &.new-search-btn {
        display: flex;
        flex-direction: row-reverse;
        @media ${theme.mediaQuery.mobileOnly} {
          padding-right: ${toRem(16)};
        }
        &:before {
          transform: rotateY(180deg);
          margin-left: ${toRem(5)};
        }
      }
    }

    @media ${theme.mediaQuery.tablet} {
      margin-left: ${toRem(24)};
      margin-right: ${toRem(24)};
    }
    @media ${theme.mediaQuery.desktop} {
      margin-left: ${toRem(32)};
      margin-right: ${toRem(32)};
    }
    @media ${theme.mediaQuery.largeDesktop} {
      margin-left: ${toRem(24)};
      margin-right: ${toRem(40)};
    }
  }
  .collapse-list-view-btn {
    display: flex;
    flex-direction: row-reverse;
    position: absolute;
    right: ${toRem(24)};
    @media ${theme.mediaQuery.desktop} {
      right: ${toRem(32)};
    }
    @media ${theme.mediaQuery.largeDesktop} {
      right: ${toRem(40)};
    }
    bottom: ${toRem(15)};
    &:before {
      transform: rotateY(180deg);
      margin-left: ${toRem(5)};
    }
  }
`}
`;
